import React, { useState } from "react";
import { Admin, Resource, CustomRoutes, defaultTheme } from "react-admin";
import { HashRouter, Routes, Route } from "react-router-dom";
import PublicMenu from "./menu/PublicMenu";
import { createTheme } from "@mui/material/styles";
import ExtraSectionCreate from "./menu/extraSections/ExtraSectionCreate";
import ReferansDashboard from "./referans/ReferansDashboard";



import LoginPage from "./LoginPage";
import dataProvider from "./dataProvider";
import MuhtarDashboard from "./MuhtarDashboard";
import CustomLayout from "./CustomLayout";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ReferansResetPasswordPage from "./referans/ReferansResetPasswordPage";
import ReferansChangePasswordPage from "./referans/ReferansChangePasswordPage";
import KurumResetPasswordPage from "./pages/KurumResetPasswordPage";
import KurumChangePasswordPage from "./pages/KurumChangePasswordPage";
import QrKodPage from "./pages/QrKodPage";  // QR Kod sayfası
import Evraklarim from "./Evraklarim/evraklarim";
import SablonEkle from './Evraklarim/SablonEkle';







import KurumList from "./components/KurumList";
import BizKimizPage from "./pages/BizKimizPage";

import DuyuruCard from "./pages/DuyuruCard";
import { DuyurularPage, DuyuruEdit } from "./pages/DuyurularPage";
import { EtkinliklerPage, EtkinlikCreate, EtkinlikEdit } from "./pages/EtkinliklerPage";
import { AnaKategorilerPage, AnaKategoriCreate, AnaKategoriEdit } from "./pages/AnaKategorilerPage";
import { FaaliyetlerPage, FaaliyetCreate, FaaliyetEdit } from "./pages/FaaliyetlerPage";
import { IletisimPage, IletisimEdit, IletisimCreate } from "./pages/IletisimPage";
import { AnketList, AnketlerPage, AnketCreate, AnketEdit } from "./pages/AnketlerPage";
import BookingPage from "./pages/BookingPage";
import RestaurantTablesPage from "./pages/RestaurantTablesPage";
import RestaurantSettingsPage from "./pages/RestaurantSettingsPage";
// 🧾 MUHASEBE & SİGORTA
import MuhasebeDashboard from "./pages/MuhasebeDashboard";
import MuhasebeBelgeler from "./pages/MuhasebeBelgeler";
import SigortaPage from "./pages/SigortaPage";
import DijitalImzaView from "./dijitalimza/DijitalImzaView";


import { GeriBildirimlerPage, GeriBildirimEdit } from "./pages/GeriBildirimlerPage";
import AyarlarPage from "./pages/AyarlarPage";
import { KullanicilarPage, KullaniciShow } from "./pages/KullanicilarPage";
import AdminLogin from "./admin/AdminLogin";



const Hidden = () => null;

const myTheme = createTheme({
  ...defaultTheme,
  palette: {
    mode: "light",
    background: {
      default: "#f5f5f5",
      paper: "#ffffff"
    }
  }
});


// ---------------------------------------------------------
// ✔ DOĞRU ROUTE YAPISI – useLocation SORUNSUZ
// ---------------------------------------------------------
export default function AppWrapper() {
  return (
    <HashRouter>
      <Routes>


 {/* 🔓 PUBLIC MENU — LOGIN YOK */}
        <Route path="/menu/:kurumId" element={<PublicMenu />} />

  <Route path="/reset-password" element={<ResetPasswordPage />} />
<Route path="/kurum/reset-password" element={<KurumResetPasswordPage />} />



    {/* 🔐 REFERANS / PANEL RESET (YENİ) */}
  <Route
    path="/referans/reset-password"
    element={<ReferansResetPasswordPage />}
  />

<Route
  path="/network-passport/reset-password"
  element={<ReferansResetPasswordPage />}
/>

<Route
  path="/referans/change-password"
  element={<ReferansChangePasswordPage />}
/>
<Route
  path="/kurum/change-password"
  element={<KurumChangePasswordPage />}
/>
  {/* 🔐 ADMIN PANEL – AYRI */}
<Route path="/admin" element={<AdminLogin />} />

  {/* ✅ REFERANS / KAZANÇ DASHBOARD */}
<Route
  path="/dashboard"
  element={
    localStorage.getItem("user_token")
      ? <ReferansDashboard />
      : <ReferansDashboard />
  }
/>



  {/* 🧑 NORMAL PANEL */}
  <Route path="/*" element={<App />} />
</Routes>

    </HashRouter>
  );
}


// ---------------------------------------------------------
// ✔ ORİJİNAL App (HİÇ BOZULMADAN KORUNDU)
// ---------------------------------------------------------
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!localStorage.getItem("token"));
  const provider = dataProvider;

  return isLoggedIn ? (
    <Admin
      dashboard={MuhtarDashboard}
      dataProvider={provider}
      layout={CustomLayout}
      theme={myTheme}
    >
      <Resource name="kurumlar" list={KurumList} />
      <Resource name="duyurular" list={DuyurularPage} create={DuyuruCard} edit={DuyuruEdit} />
      <Resource name="etkinlikler" list={EtkinliklerPage} create={EtkinlikCreate} edit={EtkinlikEdit} />
      <Resource name="anakategoriler" list={AnaKategorilerPage} create={AnaKategoriCreate} edit={AnaKategoriEdit} />
      <Resource name="faaliyetler" list={FaaliyetlerPage} create={FaaliyetCreate} edit={FaaliyetEdit} />
      <Resource name="iletisim" list={IletisimPage} edit={IletisimEdit} create={IletisimCreate} />
     <Resource name="anketler" list={AnketList} create={AnketCreate} edit={AnketEdit} />
<Resource
  name="extra-sections"
  create={ExtraSectionCreate}
/>

      <Resource name="geribildirimler" list={GeriBildirimlerPage} edit={GeriBildirimEdit} />
      <Resource name="geribildirim_yanitlari" list={Hidden} create={Hidden} />
<Resource
  name="evraklarim"
  options={{ label: "📁 Evraklarım" }}
  list={Evraklarim}
/>

      <Resource
        name="kullanicilar"
        options={{ label: "Kullanıcılar" }}
        list={KullanicilarPage}
        show={KullaniciShow}
      />


      <CustomRoutes>
        <Route path="/bizkimiz" element={<BizKimizPage />} />
        <Route path="/ayarlar" element={<AyarlarPage />} />
  {/* 📅 RANDEVULAR MODÜLÜ */}
  <Route path="/randevular" element={<BookingPage />} />
  <Route path="/restoran-masalar" element={<RestaurantTablesPage />} /> 


    {/* 📄 DİJİTAL İMZA MODÜLÜ */}
    <Route path="/dijital-imza" element={<DijitalImzaView />} />

  <Route path="/evraklarim/sablon-ekle" element={<SablonEkle />} />

  
  <Route
    path="/ayarlar/restoran"
    element={<RestaurantSettingsPage />}
  />
  {/* =========================
      🧾 MUHASEBE & SİGORTA
     ========================= */}
  <Route path="/muhasebe" element={<MuhasebeDashboard />} />
  <Route path="/muhasebe/belgeler" element={<MuhasebeBelgeler />} />
  <Route path="/muhasebe/sigorta" element={<SigortaPage />} />
  <Route path="/qr-kod" element={<QrKodPage />} />



      </CustomRoutes>



      <Resource name="ayarlar" list={AyarlarPage} />
    </Admin>
  ) : (
    <LoginPage onLoginSuccess={() => setIsLoggedIn(true)} />
  );
}



